'use client'

import { useState } from 'react'
import { PortableText, type PortableTextBlock } from '@portabletext/react'
import { portableTextComponents } from './PortableTextComponents'
import clsx from 'clsx'
import { Prose } from '../Prose'

export type TabItem = {
  title: string
  content: PortableTextBlock[]
}

export type TabGroupProps = {
  tabs: TabItem[]
}

const TabGroup = ({ value }: { value: TabGroupProps }): JSX.Element => {
  const [activeTab, setActiveTab] = useState(0)
  const { tabs = [] } = value

  if (!tabs.length) return <></>

  return (
    <div className="prose my-4 !min-w-full">
      <div className="flex w-full gap-6 border-b border-slate-800">
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveTab(index)}
            className={clsx(
              'border-b px-0 py-3 text-sm font-semibold leading-6 transition-colors duration-75 focus:outline-none',
              activeTab === index
                ? 'border-sky-500 text-sky-500'
                : 'border-transparent text-slate-400 hover:border-slate-700'
            )}
          >
            {tab.title}
          </button>
        ))}
      </div>
      <div className="w-full py-4 md:py-6">
        {tabs[activeTab] && (
          <Prose className="!w-full font-sans">
            <PortableText
              value={tabs[activeTab].content}
              components={portableTextComponents}
            />
          </Prose>
        )}
      </div>
    </div>
  )
}

export default TabGroup
